import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";
import Tag from "@/components/base/Tag";

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={work.cover}
          alt={`${work.title} 海报`}
          title={`${work.title} - 朝桐光影视作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-950/80 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-950/80 px-2 py-0.5 text-xs font-semibold text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-accent-400"></i>
          {work.rating.toFixed(1)}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-semibold text-foreground-950">
          {work.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <h3 className="truncate text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {work.year} · {work.type} · {work.region}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.genre.slice(0, 2).map((g) => (
            <Tag key={g} tone="muted">
              {g}
            </Tag>
          ))}
        </div>
      </div>
    </Link>
  );
}